import { Module } from 'vuex';
import { GeeksManagementModule, GeeksManagementState } from './management-geeks.module';
import { RootState } from './root.store';

export interface ManagementState {
  geeksManagement: GeeksManagementState;
}

export const ManagementModule: Module<ManagementState, RootState> = {
  state: {
    geeksManagement: GeeksManagementModule.state as GeeksManagementState,
  },

  modules: {
    geeksManagement: GeeksManagementModule,
  },
};
